var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCreate5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 39,
    viewBox: "0 0 37 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.6588 6.93533L29.9057 29.351C29.5468 30.9327 28.612 31.3265 27.2833 30.5817L20.0406 25.2447L16.5463 28.6062C16.1593 28.9932 15.8365 29.3161 15.0906 29.3161L15.6115 21.9406L29.0338 9.81196C29.6177 9.29221 28.9067 9.00308 28.1271 9.52396L11.5333 19.973L4.3896 17.7365C2.83597 17.2516 2.80785 16.1828 4.7136 15.437L32.6552 4.67183C33.949 4.18696 35.0807 4.95983 34.6588 6.93646V6.93533Z",
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.6588 9.93533L28.9057 32.351C28.5468 33.9327 27.612 34.3265 26.2833 33.5817L19.0406 28.2447L15.5463 31.6062C15.1593 31.9932 14.8365 32.3161 14.0906 32.3161L14.6115 24.9406L28.0338 12.812C28.6177 12.2922 27.9067 12.0031 27.1271 12.524L10.5333 22.973L3.3896 20.7365C1.83597 20.2516 1.80785 19.1828 3.7136 18.437L31.6552 7.67183C32.949 7.18696 34.0807 7.95983 33.6588 9.93646V9.93533Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCreate5);
export default __webpack_public_path__ + "static/media/icon-create-5.0c5f0874daaa58ca2ba23e388e05c4b5.svg";
export { ForwardRef as ReactComponent };